enum Asset {
  Place = 'Place',
  MyExperiences = 'MyExperiences',
  SharedExperiences = 'SharedExperiences',
  TShirt = 'TShirt',
  Shirt = 'Shirt',
  Pants = 'Pants',
  Hat = 'Hat',
  HairAccessory = 'HairAccessory',
  FaceAccessory = 'FaceAccessory',
  NeckAccessory = 'NeckAccessory',
  ShoulderAccessory = 'ShoulderAccessory',
  FrontAccessory = 'FrontAccessory',
  BackAccessory = 'BackAccessory',
  WaistAccessory = 'WaistAccessory',
  TShirtAccessory = 'TShirtAccessory',
  ShirtAccessory = 'ShirtAccessory',
  PantsAccessory = 'PantsAccessory',
  JacketAccessory = 'JacketAccessory',
  SweaterAccessory = 'SweaterAccessory',
  ShortsAccessory = 'ShortsAccessory',
  DressSkirtAccessory = 'DressSkirtAccessory',
  EyebrowAccessory = 'EyebrowAccessory',
  EyelashAccessory = 'EyelashAccessory',
  FaceMakeup = 'FaceMakeup',
  LipMakeup = 'LipMakeup',
  EyeMakeup = 'EyeMakeup',
  Decal = 'Decal',
  Image = 'Image',
  Audio = 'Audio',
  Model = 'Model',
  Mesh = 'Mesh',
  MeshPart = 'MeshPart',
  Plugin = 'Plugin',
  EmoteAnimation = 'EmoteAnimation',
  Animation = 'Animation',
  Video = 'Video',
  Event = 'Event',
  UpcomingEvent = 'UpcomingEvent',
  DraftEvent = 'DraftEvent',
  PastEvent = 'PastEvent',
  FontFamily = 'FontFamily',
  ShareLink = 'ShareLink',
  StorePreviewVideo = 'StorePreviewVideo',
  GamePreviewVideo = 'GamePreviewVideo',
  // For 'All' pill under Avatar Items
  AllCatalogAsset = 'All',
}

export default Asset;
